import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';

export function inventorySummaryStart({
  outletIds,
  startDate,
  endDate,
  namespace,
}) {
  pushClevertapEvent('Inventory Summary Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace,
  });
}
